<div class="modal-header" style="border-bottom: 1px solid #DDD;">
  <div class="d-flex justify-content-between w-100 py-2" style="height: 55px;">
    <!-- Editable Heading -->
    <div class="flex-grow-1 d-flex align-items-center gap-2 justify-content-between">
      <h2 class="card-title">{{headingText}}</h2>

      <div class="d-flex justify-content-end gap-2">
        <!-- <button type="button" class="back-button" *ngIf="showFontSelector" (click)="closeFontSelector()" aria-label="Go back">
          <img src="assets/images/custom/switch.svg" style="width:20px; margin-right: 5px;">Back
        </button>
        <button type="button" class="back-button" *ngIf="isDrawMode" (click)="exitDrawMode()" aria-label="Go back">
          <img src="assets/images/custom/switch.svg" style="width:20px; margin-right: 5px;">Type Signature
        </button> -->
        <button
          type="button"
          class="save-signature-btn"
          *ngIf="showSignatureForm"
          [disabled]="isSaving || !canSaveSignature || (showFontSelector && !isDrawMode)"
          (click)="onSaveSignature()"
        >
          {{ isSaving ? 'Saving...' : 'Save' }}
        </button>
      </div>
    </div>

    <div class="d-flex justify-content-between">
      <button
        id="close-referral-modal-btn"
        type="button"
        class="btn-close close pull-right"
        style="margin-top: 1px; margin-left: 8px;"
        aria-label="Close"
        (click)="closeModal()"
      >
        <span aria-hidden="true" class="visually-hidden">&times;</span>
      </button>
    </div>
  </div>
</div>
<div class="modal-body">
  <div class="profile-widget" *ngIf="!showSignatureForm && (userFullName || userEmail || userPhone || organizationName || organizationAddress)">
    <div class="profile-avatar" aria-hidden="true">{{ userInitials || '--' }}</div>
    <div class="profile-content">
      <div class="profile-section profile-left">
        <div class="profile-name">{{ userFullName || 'User' }}</div>
        <div class="profile-contact" *ngIf="userEmail || userPhone">
          <span class="contact-value" *ngIf="userPhone">{{ userPhone }}</span>
          <span class="contact-separator" *ngIf="userEmail && userPhone">|</span>
          <span class="contact-value" *ngIf="userEmail">{{ userEmail }}</span>
        </div>
      </div>
      <div class="profile-section profile-right" *ngIf="organizationName || organizationAddress">
        <div class="organization-name">{{ organizationName || 'Organization' }}</div>
        <div class="organization-address" *ngIf="organizationAddress">{{ organizationAddress }}</div>
      </div>
    </div>
  </div>

  <!-- PIN Box -->
  <div class="pin-widget" *ngIf="!showSignatureForm && !showPinSection && (userFullName || userEmail || userPhone || organizationName || organizationAddress)">
    <button 
      type="button" 
      class="pin-action-btn" 
      (click)="onShowPinSection()"
    >
      {{ hasPin ? 'View Pin' : 'Add Pin' }}
    </button>
  </div>

  <!-- PIN Section -->
  <div class="pin-section" *ngIf="!showSignatureForm && showPinSection">
    <button 
      type="button" 
      class="close-pin-link" 
      (click)="onHidePinSection()"
      style="position: absolute; top: 10px; right: 10px; background: none; border: none; color: #666; font-size: 16px; cursor: pointer; padding: 5px;"
      aria-label="Close"
    >
      <i class="fa fa-times" aria-hidden="true"></i>
    </button>
    <div class="form-group" style="width: 100%; max-width: 600px; text-align: center;">
      <div class="d-flex gap-2 align-items-center justify-content-center" style="gap: 12px; flex-wrap: wrap;">
        <div class="d-flex gap-2 pin-container" (paste)="onPinPaste($event)">
          <input
            #pinInput0
            [attr.data-pin-index]="0"
            class="form-control pin-box"
            type="text"
            inputmode="numeric"
            pattern="[0-9]*"
            maxlength="1"
            [value]="pinDigits[0]"
            (input)="onPinInput($event, 0)"
            (keydown)="onPinKeyDown($event, 0)"
            autocomplete="off"
          />
          <input
            #pinInput1
            [attr.data-pin-index]="1"
            class="form-control pin-box"
            type="text"
            inputmode="numeric"
            pattern="[0-9]*"
            maxlength="1"
            [value]="pinDigits[1]"
            (input)="onPinInput($event, 1)"
            (keydown)="onPinKeyDown($event, 1)"
            autocomplete="off"
          />
          <input
            #pinInput2
            [attr.data-pin-index]="2"
            class="form-control pin-box"
            type="text"
            inputmode="numeric"
            pattern="[0-9]*"
            maxlength="1"
            [value]="pinDigits[2]"
            (input)="onPinInput($event, 2)"
            (keydown)="onPinKeyDown($event, 2)"
            autocomplete="off"
          />
          <input
            #pinInput3
            [attr.data-pin-index]="3"
            class="form-control pin-box"
            type="text"
            inputmode="numeric"
            pattern="[0-9]*"
            maxlength="1"
            [value]="pinDigits[3]"
            (input)="onPinInput($event, 3)"
            (keydown)="onPinKeyDown($event, 3)"
            autocomplete="off"
          />
        </div>
        <button
          type="button"
          class="btn btn-primary save-pin-btn"
          [disabled]="isSavingPin || !userPin || userPin.length !== 4"
          (click)="onSavePin()"
        >
          {{ isSavingPin ? 'Saving...' : (hasPin ? 'Update PIN' : 'Save PIN') }}
        </button>
      </div>
      <!-- <small class="text-muted" style="display: block; margin-top: 12px;">Enter a 4-digit PIN for your account</small> -->
    </div>
  </div>

  <div class="signature-body" *ngIf="!showSignatureForm" [ngClass]="{ 'has-saved-signature': savedSignatureDataUrl }">
    <ng-container *ngIf="savedSignatureDataUrl; else defaultSignaturePreview">
      <img [src]="savedSignatureDataUrl" alt="Saved signature" class="signature-image saved-signature-image">
    </ng-container>
    <ng-template #defaultSignaturePreview>
      <img src="assets/images/custom/signed.png" alt="Signature" class="signature-image">
    </ng-template>
    <button type="button" class="signature-link" (click)="openSignatureForm()">
      {{ signatureActionLabel }}
    </button>
  </div>

  <div class="signature-wrapper" *ngIf="showSignatureForm">
    <ng-container *ngIf="!showFontSelector; else fontSelector">
      <div class="signature-card">

        <ng-container *ngIf="!isDrawMode">
          <div class="form-group">
            <label class="field-label" for="signatureName" style="color:#646978;">Type Your Signature</label>
            <input
              style="color:#3F3F3F !important;"
              id="signatureName"
              class="signature-input"
              type="text"
              placeholder="e.g., John Doe"
              [value]="typedName"
              (input)="onNameInput($event)"
              autocomplete="off"
            />
          </div>
  
          <div class="preview-card">
            <div class="d-flex justify-content-between">
              <span class="preview-label">Preview</span>
              <button type="button" class="change-style-btn p-0 m-0" (click)="openFontSelector()">Change style</button>
            </div>
            <div class="signature-preview" [ngStyle]="{ 'font-family': currentFont }">
              {{ typedName || 'Preview Signature' }}
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="isDrawMode">
          <div class="signature-card">
            <div class="canvas-wrapper">
              <canvas
                #signatureCanvas
                class="signature-canvas"
                (mousedown)="startDrawing($event)"
                (mousemove)="draw($event)"
                (mouseup)="stopDrawing()"
                (mouseleave)="stopDrawing()"
              ></canvas>
              <div class="divider">
              </div>
              <div class="d-flex justify-content-center">
                <span class="draw-signature-text">Draw your signature</span>
              </div>
              <div class="primary-actions">
                <button type="button" class="clear-signature-btn" (click)="clearCanvas()"><i class="fa-solid fa-paintbrush" style="color: #CCC;"></i>Clear</button>
              </div>
            </div>
          </div>
        </ng-container>

        <div class="divider">
          <span>OR</span>
        </div>

        <div class="d-flex justify-content-between">
          <div
            class="signature-body signature-draw-trigger d-flex align-items-center justify-content-center"
            [class.selected]="!isDrawMode"
            style="height: 60px !important; width: 49%; flex-direction:row;"
            role="button"
            tabindex="0"
            (click)="exitDrawMode()"
            (keydown.enter)="exitDrawMode()"
            (keydown.space)="exitDrawMode()"
          >
            <i class="fa fa-keyboard" aria-hidden="true" style="font-size: 20px;"></i>
            <span class="signature-link">Type</span>
          </div>

          <div
            class="signature-body signature-draw-trigger d-flex align-items-center justify-content-center"
            [class.selected]="isDrawMode"
            style="height: 60px !important; width: 49%; flex-direction:row;"
            role="button"
            tabindex="0"
            (click)="enterDrawMode()"
            (keydown.enter)="enterDrawMode()"
            (keydown.space)="enterDrawMode()"
          >
            <img src="assets/images/custom/signed.png" alt="Signature" class="signature-image">
            <span class="signature-link">Draw</span>
          </div>
        </div>

      </div>

      
    </ng-container>

    <ng-template #fontSelector>
      <div class="signature-card font-selector-card">
        <div class="font-selector-grid">
          <button
            type="button"
            class="font-tile"
            [class.active]="i === currentFontIndex"
            *ngFor="let font of signatureFonts; index as i"
            (click)="selectFont(i)"
          >
            <span [ngStyle]="{ 'font-family': font }">{{ typedName || 'Sample Signature' }}</span>
          </button>
        </div>
      </div>
    </ng-template>
  </div>
</div>
